import axios from "axios";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Back from "../components/button/back";

const KURKUM = () => {
  const [tujuanPembelajaran, setTujuanPembelajaran] = useState([]);
  const [kelas, setKelas] = useState("");
  const [semester, setSemester] = useState("");
  const [mapel, setMapel] = useState("");
  const [rombel, setRombel] = useState(""); // state baru untuk rombel
  const [existingTPData, setExistingTPData] = useState([]);
  const [savedMessage, setSavedMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [duplicateDataMessage, setDuplicateDataMessage] = useState("");

  const navigate = useNavigate();
  const location = useLocation();

  const handleBack = () => {
    // ambil halaman sebelumnya dari state
    const from = location.state?.from;

    if (from) {
      navigate(from);
    } else {
      // fallback jika tidak ada state
      navigate(-1);
    }
  };

  useEffect(() => {
    fetchExistingTPData();
  }, []);

  const fetchExistingTPData = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}api/tp`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      setExistingTPData(response.data);
    } catch (error) {
      console.error("Error fetching existing TP data:", error);
    }
  };

  const tambahTujuanPembelajaran = () => {
    setTujuanPembelajaran([...tujuanPembelajaran, ""]);
  };

  const handleInputChange = (index, event) => {
    const values = [...tujuanPembelajaran];
    values[index] = event.target.value;
    setTujuanPembelajaran(values);
  };

  const hapusTujuanPembelajaran = (index) => {
    const values = [...tujuanPembelajaran];
    values.splice(index, 1);
    setTujuanPembelajaran(values);
  };

  const handleSave = async () => {
    if (
      !kelas ||
      !semester ||
      !mapel ||
      !rombel ||
      tujuanPembelajaran.some((tp) => !tp)
    ) {
      setErrorMessage("Semua input wajib diisi.");
      return;
    }

    try {
      const token = localStorage.getItem("token");

      // Filter duplicate data dengan rombel juga
      const existingData = existingTPData.filter(
        (data) =>
          data.kelas === kelas &&
          data.semester === semester &&
          data.mapel === mapel &&
          data.rombel === rombel,
      );

      if (existingData.length > 0) {
        setDuplicateDataMessage(
          "Data dengan kelas, rombel, semester, dan mata pelajaran tersebut sudah ada.",
        );
        setSavedMessage("");
        setErrorMessage("");
        return;
      }

      const tpPayload = tujuanPembelajaran.map((tp, index) => ({
        isiTP: tp,
        nomor: `TP${index + 1}`,
      }));

      await axios.post(
        `${process.env.REACT_APP_API_URL}api/tp`,
        {
          mapel,
          kelas,
          rombel, // kirim rombel
          semester,
          TP: tpPayload,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      fetchExistingTPData();
      setSavedMessage("Data berhasil disimpan.");
      setErrorMessage("");
      setDuplicateDataMessage("");
    } catch (error) {
      console.error("Error saving TP:", error);
      setSavedMessage("Gagal menyimpan data.");
    }
  };

  const renderInputs = () =>
    tujuanPembelajaran.map((tp, index) => (
      <tr key={index}>
        <td>{`TP${index + 1}:`}</td>
        <td>
          <textarea
            value={tp}
            onChange={(e) => handleInputChange(index, e)}
            className="p-2 md:w-[500px] border border-slate-500 rounded-lg"
            maxLength={120}
            placeholder={`Masukkan tujuan pembelajaran ${index + 1}`}
          />
        </td>
        <td>
          <button
            onClick={() => hapusTujuanPembelajaran(index)}
            className="bg-red-500 px-5 py-2 rounded-lg"
          >
            Hapus
          </button>
        </td>
      </tr>
    ));

  return (
    <div className="min-h-screen bg-blue-100 py-10">
      <div className="bg-white mx-5 p-5 rounded-lg drop-shadow-lg">
        <div className="flex justify-center py-5">
          <h1 className="font-bold text-2xl">Kurikulum Merdeka</h1>
        </div>

        <div className="grid gap-y-4 border border-slate-500 rounded-lg p-5 bg-white">
          {/* Pilihan Kelas */}
          <div className="flex items-center">
            <label className="w-1/4 font-medium">Kelas:</label>
            <select
              value={kelas}
              onChange={(e) => setKelas(e.target.value)}
              className="flex-1 border border-slate-500 rounded-lg px-3 py-2"
            >
              <option value="">Pilih Kelas</option>
              {[1, 2, 3, 4, 5, 6].map((kelas) => (
                <option key={kelas} value={kelas}>
                  {kelas}
                </option>
              ))}
            </select>
          </div>

          {/* Pilihan Rombel */}
          <div className="flex items-center">
            <label className="w-1/4 font-medium">Rombel:</label>
            <select
              value={rombel}
              onChange={(e) => setRombel(e.target.value)}
              className="flex-1 border border-slate-500 rounded-lg px-3 py-2"
            >
              <option value="">Pilih Rombel</option>
              {["A", "B", "C", "D"].map((r) => (
                <option key={r} value={r}>
                  {r}
                </option>
              ))}
            </select>
          </div>

          {/* Pilihan Semester */}
          <div className="flex items-center">
            <label className="w-1/4 font-medium">Semester:</label>
            <select
              value={semester}
              onChange={(e) => setSemester(e.target.value)}
              className="flex-1 border border-slate-500 rounded-lg px-3 py-2"
            >
              <option value="">Pilih Semester</option>
              {[1, 2].map((semester) => (
                <option key={semester} value={semester}>
                  {semester}
                </option>
              ))}
            </select>
          </div>

          {/* Pilihan Mata Pelajaran */}
          <div className="flex items-center">
            <label className="w-1/4 font-medium">Mata Pelajaran:</label>
            <select
              value={mapel}
              onChange={(e) => setMapel(e.target.value)}
              className="flex-1 border border-slate-500 rounded-lg px-3 py-2"
            >
              <option value="">Pilih Mata Pelajaran</option>
              {[
                "MTK",
                "BIndo",
                "BIng",
                "IPAS",
                "PKN",
                "PJOK",
                "MULOK",
                "SENIBUDAYA",
                "PAI",
                "Koding",
              ].map((subject) => (
                <option key={subject} value={subject}>
                  {subject}
                </option>
              ))}
            </select>
          </div>

          {/* Tabel Input */}
          <div className="flex justify-center mt-4">
            <table className="border border-slate-400 w-full text-sm text-center">
              <tbody>{renderInputs()}</tbody>
            </table>
          </div>

          {/* Tombol Tambah dan Pesan */}
          <div className="flex flex-col items-center gap-2 mt-5">
            <button
              onClick={tambahTujuanPembelajaran}
              className="bg-green-500 text-white rounded-lg px-5 py-2 hover:bg-green-600"
            >
              Tambah TP
            </button>
            {savedMessage && <p className="text-green-600">{savedMessage}</p>}
            {duplicateDataMessage && (
              <p className="text-orange-500">{duplicateDataMessage}</p>
            )}
            {errorMessage && <p className="text-red-500">{errorMessage}</p>}
          </div>
        </div>

        <div className="flex justify-center my-5">
          <button
            onClick={handleSave}
            className="bg-blue-400 px-5 py-2 rounded-lg"
          >
            Simpan TP
          </button>
        </div>
      </div>
      <div className="flex justify-center mt-5">
        <button onClick={handleBack}>
          <Back />
        </button>
      </div>
    </div>
  );
};

export default KURKUM;
